import { render, staticRenderFns } from "./NewOtherInvestigation.vue?vue&type=template&id=5f86ac3c&scoped=true"
import script from "./NewOtherInvestigation.vue?vue&type=script&lang=js"
export * from "./NewOtherInvestigation.vue?vue&type=script&lang=js"
import style0 from "./NewOtherInvestigation.vue?vue&type=style&index=0&id=5f86ac3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f86ac3c",
  null
  
)

export default component.exports